export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_01.41019bb3.jpg";